"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable */
var load_themed_styles_1 = require("@microsoft/load-themed-styles");
load_themed_styles_1.loadStyles([{ "rawString": ".root_66073841{display:inline-block}\n" }]);
exports.root = "root_66073841";
//# sourceMappingURL=GroupSpacer.scss.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/office-ui-fabric-react/lib/components/GroupedList/GroupSpacer.scss.js
// module id = 924
// module chunks = 0